import { AccessPermissions } from '@circlefin/permissions'
import { Role } from '@circlefin/permissions/roles'

import type { PermissionSet } from '@circlefin/permissions'

/**
 * Can a user vote on a proposal?
 */
export const VOTE_ON_PROPOSAL_MUTATION: PermissionSet = {
  access: AccessPermissions.protected,
  includeAll: [Role.PROPOSAL_MANAGEMENT_ROLE],
}
